<ng-template [ngIf]="addionalOffersArray.length > 0">
  <h2 class="p-2 mt-3 mb-0">Additional Offers</h2>
  <!-- Top content -->
  <div id="carouselExample" class="carousel slide m-2" data-ride="carousel" data-interval="3000">
    <div class="carousel-inner row w-100 mx-auto flex-nowrap" role="listbox">
      <div
        class="carousel-item col-12 col-sm-3 col-md-3 col-lg-3"
        *ngFor="let offerItem of addionalOffersArray; let i = index"
        [class.active]="selectedIndexno === i"
        [class.clickedItem]="seletcedItemIndex === i"
        (click)="triggerSearchFlightRequest(offerItem, i)"
      >
        <div class="row">
          <div class="details col-12">
            <span>{{ offerItem.fromDate | date | dateFormat : 'dd MMM' }} </span>
            <span *ngIf="offerItem.toDate"> - {{ offerItem.toDate | dateFormat : 'dd MMM' }} </span><br />
            <span class="price"> {{ offerItem.totalPrice }} {{ offerItem.currencyCode }} </span>
          </div>
        </div>
      </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExample" role="button" data-slide="prev">
      <i class="fa fa-chevron-left fa-lg text-muted"></i>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next text-faded" href="#carouselExample" role="button" data-slide="next">
      <i class="fa fa-chevron-right fa-lg text-muted"></i>
      <span class="sr-only">Next</span>
    </a>
  </div>

  <div class="modal fade in featureGuide" id="featureGuideSecond" tabindex="-1" role="dialog" aria-labelledby="ocnModalTitle" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div>
          <div class="modal-header">
            <h5 class="modal-title" id="ocnModalTitle">Newly added Features</h5>
          </div>
          <div class="modal-body">
            <ul class="slides_container" id="slides">
              <li class="featureSlide active" *ngFor="let newFeature of newFeatures.newfeatureSectionCard">
                <h5>{{ newFeature.title }}</h5>
                <div [innerHtml]="returnHtmlFromRichText(newFeature.richTextBody) || '' | mdToHtml"></div>
                <img src="{{ newFeature.headImage }}" />
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateGuideVisit('timeDayFeature')">Close</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateGuideVisit('timeDayFeature')">Skip</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<h2 class="p-2 mt-3 mb-0">Airline Offers</h2>
<ng-template [ngIf]="pNumberList.length > 0">
  <nav aria-label="Page navigation example">
    <ul class="pagination">
      <li class="page-item">
        <a class="page-link" (click)="triggerPagination('back')" aria-label="Previous">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>

      <li *ngFor="let p of pNumberList" [class.active]="p.start === pSettings.start" class="page-item">
        <a class="page-link" (click)="updateStart(p.start)">{{ p.label }}</a>
      </li>

      <li class="page-item">
        <a class="page-link" (click)="triggerPagination('next')" aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
</ng-template>
<ng-template [ngIf]="airlineOffersScreen.airlineOffers.length > 0">
  <div *ngFor="let airlineOffer of airlineOffersScreen.airlineOffers; let airLineOffersIndex = index">
    <div class="row air-offer p-2">
      <div class="col-sm-9 card offer cutCornerBRt cutCornerRt">
        <div *ngFor="let boundDetails of airlineOffer.boundAirlineOffer; let boundIndex = index; let boundFirstIndex = first; let boundLastIndex = last">
          <div
            *ngFor="let flightDetail of boundDetails?.flightDetails; let flightIndex = index; let flightLastIndex = last; let flightFirstIndex = first"
            [class.mb-2]="boundFirstIndex"
            [class.mt-2]="boundLastIndex"
            class="od2"
          >
            <div class="row p-1">
              <div class="col-sm-1">
                <img *ngIf="getFlightLogoUrl(flightDetail.airlineName) !== ''" class="pt-10" [src]="getFlightLogoUrl(flightDetail.airlineName)" />
              </div>
              <div class="col-sm-2">
                <div class="flt-date">{{ flightDetail.departureDate }}</div>
              </div>
              <div class="col-sm-3">
                <div class="fltgrp">
                  <div class="fl-time">{{ flightDetail.departureTimeIn24H }}</div>
                  <div class="fl-airpt">
                    <div class="sm-text">{{ flightDetail.departureAirportName }}</div>
                    {{ flightDetail.departureAirportCode }}
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div style="text-align: center">
                  <span style="font-size: 12px">{{ flightDetail.duriation }} </span>
                  <ul class="Leg-line"></ul>
                  <span style="font-size: 12px; color: #074e11"
                    >{{ flightDetail.airlineId }}{{ flightDetail.airlineNumber }} | {{ flightDetail.flightType }} | {{ flightDetail.flightCode1 }} {{ flightDetail.flightCode2 }}
                  </span>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="fl-time">{{ flightDetail.arrivalTimeIn24H }}</div>
                <div class="fl-airpt">
                  <div class="sm-text">{{ flightDetail.arrivalAirportName }}</div>
                  {{ flightDetail.arrivalAirportCode }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 wd110">
                <span class="pad-title">{{ flightDetail.marketingName }}</span
                ><br />
                <span class="pad-title">{{ flightDetail.economyType }} </span><br />
              </div>
              <div class="col-sm-6 wd110">
                <i *ngIf="flightDetail.iconsStatus?.baChangesFee === 'true'" class="baIcn ba-changes-fee ba-1x" title="Changes Permitted with a Fee"></i>
                <i *ngIf="flightDetail.iconsStatus?.baChangesFee === 'false'" class="baIcn ba-history ba-1x" title="Change Time/Date Permitted"></i>
                <i *ngIf="flightDetail.iconsStatus?.baRefund === 'true' && flightDetail.iconsStatus?.cancelFee === 'true'" class="baIcn ba-refund ba-1x rfndGreen" title="Cancel Fee"></i>
                <i *ngIf="flightDetail.iconsStatus?.cancelFee === 'false' && flightDetail.iconsStatus?.baRefund === 'true'" class="baIcn ba-refund ba-1x rfndGreen" title="Refundable"></i>
                <i *ngIf="flightDetail.iconsStatus?.remark === 'No changes permitted. No upgrades permitted'" class="baIcn ba-airplane-cancel red ba-1x" title="Changes Not Permitted"></i>
                <i *ngIf="flightDetail.iconsStatus?.baRefund === 'false'" class="baIcn ba-norefund ba-1x red" title="Non Refundable"></i><br />
                <i class="baIcn ba-handbag ba-2x ba-mg-2" title="Handbag"></i><i class="baIcn ba-carryOn-bag ba-3x ba-mg-2" title="Carry-On Bag"></i>
                <i *ngIf="flightDetail.iconsStatus?.baCheckBag" class="baIcn ba-check-bag ba-3x" title="Checked In Bag"></i>
              </div>
            </div>

            <div class="small-text ms-2">Operated by {{ flightDetail.opperatingCarrierName }}</div>
            <ng-template [ngIf]="flightIndex === 0">
              <div (click)="toggleRules(airLineOffersIndex, boundIndex)">
                <ng-template [ngIf]="boundDetails.displayRule">
                  <i class="icon-arrowUp"></i>
                </ng-template>
                <ng-template [ngIf]="!boundDetails.displayRule">
                  <i class="icon-arrowDown"></i>
                </ng-template>
                Rules
              </div>
            </ng-template>
            <ng-template [ngIf]="flightLastIndex">
              <ng-template [ngIf]="boundDetails.displayRule">
                <div class="mt-2 ms-4 p-2 onlyRules srchODpn">
                  <div *ngFor="let rules of boundDetails.rules">
                    <label>{{ rules?.label }}</label>
                    <br />
                    {{ rules?.remark }}
                  </div>
                </div>
              </ng-template>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="col-sm-3 card p-4 offer cut-corner-Lt cut-corner-BLt dashLt">
        <div class="small-text row float-right">
          <span>PUBLISHED | {{ airlineOffer.priceDetail.negotiationStatus }}</span>
        </div>
        <div class="clearfix"></div>
        <div class="row flight-Price">
          {{ roundOffAirlinePriceDetails(airlineOffer.priceDetail.price) }}<span class="sm-cur mt-4">{{ airlineOffer.priceDetail.currency }}</span>
        </div>
        <div class="clearfix"></div>
        <div class="flPricepn mt-2"><button role="button" (click)="getSelectedOfferPrice(airlineOffer.offerIndex)" class="ba-btn sml">Select Offer</button></div>
      </div>
    </div>
  </div>
</ng-template>
